<template>
  <div>
    <b-card-body>
      <div class="row mx-md-n3 mx-1 mb-2 align-items-end">
        <div class="col-sm-6 col-12 mb-sm-0 mb-3">
          <b-form-group
            label="Nome"
            label-for="locationsSearchText"
            class="mb-0"
          >
            <b-form-input
              id="locationsSearchText"
              v-model="locationsSearchText"
              @keyup.enter="searchButtonClicked"
              placeholder="Procurar por..."
            />
          </b-form-group>
        </div>
        <div class="col-sm-auto col-6">
          <b-dropdown text="Filtros" class="mobile-btn-100">
            <b-dropdown-form>
              <b-form-group
                label="Armazém"
              >
                <div v-if="loadingWarehouses">
                  <loading-animation />
                </div>
                <model-list-select
                  :list="warehouses"
                  option-value="id"
                  option-text="name"
                  v-model="locationsSelectedWarehouse"
                  placeholder="Selecione o Armazém"
                />
              </b-form-group>
              <b-form-group
                label="Lote"
              >
                <div v-if="lotsFilter.loading">
                  <loading-animation />
                </div>
                <model-list-select
                  :list="lotsFilter.lots"
                  option-value="id"
                  option-text="lotNumber"
                  v-model="locationsSelectedLot"
                  placeholder="Digite para pesquisar"
                  @searchchange="searchLots"
                  :filterPredicate="alwaysTrueFilterPredicate"
                />
              </b-form-group>
              <b-form-group
                label="Apenas com saldo positivo"
              >
                <b-form-checkbox v-model="positiveLocation"></b-form-checkbox>
              </b-form-group>
            </b-dropdown-form>
          </b-dropdown>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-6">
          <button @click="searchButtonClicked" type="button" class="btn btn-primary mobile-btn-100">Buscar</button>
        </div>
      </div>

      <div v-if="locationAppliedFilters.length" class="row mb-2 mx-0">
        <div v-for="(filter, index) in locationAppliedFilters" class="col-auto px-1" :key="index">
          <h5>
            <span class="badge badge-warning">{{filter.label}} = {{filter.value}}</span>
          </h5>
        </div>
      </div>

      <div class="row mx-md-n3 mx-1 mt-3" v-if="hasAllocations">
        <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12" v-for="(allocation, index) in item.locations" :key="index">
          <div class="card">
            <div class="card-body mx-md-0 mx-3">
              <h6 class="mb-4 text-muted text-right">{{ allocation.stockLocale ? allocation.stockLocale.name : '' }}</h6>
              <div class="h4 mb-0 cursor-pointer"  :id="allocation.id">
                {{ allocation.quantity }}
                <!-- <b-popover
                  placement="right"
                  :target="allocation.uuid">

                  <b-card-body>
                    <div v-for="lot in allocation.lots">
                      <p>Identificador: <strong>{{lot.identifier}}</strong></p>
                      <p>Data: <strong>{{lot.date}}</strong></p>
                      <p>Quantidade: <strong>{{lot.quantity}}</strong></p>
                    </div>
                  </b-card-body>

                </b-popover> -->
              </div>

              <h4 class="font-weight-bold mt-1">{{ allocation.name }}</h4>
              <div class="text-muted small">{{ allocation.barcode }}</div>
              <div class="text-muted small">{{ allocation.address }}</div>
              <div class="text-center mt-3">
                <small class="text-muted text-uppercase font-weight-bold text-center">
                  {{allocation.quantity}} / {{allocation.quantityMax}}
                </small>
              </div>
              <b-progress height={} class="progress-xs mt-0 mb-0" variant="success"
                          :value="(allocation.quantity / allocation.quantityMax) * 100"/>
              <small class="text-muted text-uppercase font-weight-bold">Quantidade x Capacidade</small>
            </div>
          </div>
        </div>
      </div>

      <b-row v-else-if="!loadingLocations" class="justify-content-center pt-3">
        <h6 class="col-auto">Nenhum endereço encontrado para a pesquisa</h6>
      </b-row>

      <div v-if="loadingLocations" class="m-3">
        <b-row class="justify-content-center pt-3">
          <h6 class="col-auto">Carregando...</h6>
        </b-row>

        <div class="row mx-md-n3 mx-1">
          <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 mb-5" v-for="index in locationsPerPage" :key="index">
            <vcl-facebook :height="100"></vcl-facebook>
          </div>
        </div>
      </div>
    </b-card-body>
  </div>
</template>

<script>
  import { LoadingAnimation } from '@/components/loaders'
  import { httpClient } from '@/service';
  import shared from '@/shared/shared'
  import { ModelListSelect } from 'vue-search-select'
  import { VclFacebook } from 'vue-content-loading';

  export default {
    name: 'item-locations',
    components: {
      LoadingAnimation,
      ModelListSelect,
      VclFacebook
    },

    props: {
      item: {
        type: Object,
        required: true
      },
      loadingWarehouses: {
        type: Boolean,
        required: true
      },
      warehouses: {
        type: Array,
        required: true
      },
      alwaysTrueFilterPredicate: {
        type: Function,
        required: true
      },
      updateItem: {
        type: Function,
        required: true
      },
      locationsSearchedCallback: {
        type: Function,
        required: true
      },
      lotsFilter: {
        type: Object,
        required: true
      },
      searchLots: {
        type: Function,
        required: true
      }
    },

    data () {
      return {
        loadingLocations: false,
        locationsSearchText: null,
        locationsSelectedWarehouse: {},
        locationsSelectedLot: {},
        positiveLocation: false,
        locationsCurrentPage: 1,
        locationsPerPage: 10,
        itemLocationsSearched: false,
        hasNextRow: true
      }
    },

    beforeMount: function () {
      this.locationsSearchText = shared.getLocalStorageString('items/show/Locations/locationsSearchText', this.locationsSearchText);
      this.locationsSelectedWarehouse = shared.getLocalStorageObj('items/show/Locations/locationsSelectedWarehouse', this.locationsSelectedWarehouse);
      this.locationsSelectedLot = shared.getLocalStorageObj('items/show/Locations/locationsSelectedLot', this.locationsSelectedLot);
      this.positiveLocation = shared.getLocalStorageString('items/show/Locations/positiveLocation', this.positiveLocation);
    },

    computed: {
      hasAllocations() {
        return this.item && this.item.locations && this.item.locations.length;
      },

      locationAppliedFilters() {
        let appliedFilters = [];

        if (this.locationsSearchText && this.locationsSearchText.length) {
          appliedFilters.push({ label: 'Nome', value: this.locationsSearchText });
        }

        if (this.locationsSelectedWarehouse && this.locationsSelectedWarehouse.id) {
          appliedFilters.push({ label: 'Armazém', value: this.locationsSelectedWarehouse.name });
        }

        if (this.locationsSelectedLot && this.locationsSelectedLot.id) {
          appliedFilters.push({ label: 'Lote', value: this.locationsSelectedLot.lotNumber });
        }

        if (this.positiveLocation) {
          appliedFilters.push({ label: 'Apenas com saldo positvo', value: 'Sim' });
        }

        return appliedFilters;
      }
    },

    methods: {
      tabChanged() {
        if (!this.itemLocationsSearched) {
          this.searchItemLocations();
          this.itemLocationsSearched = true;
        }
      },

      searchButtonClicked() {
        this.resetLocations();
        this.searchItemLocations();
      },

      resetLocations() {
        this.hasNextRow = true;
        this.locationsCurrentPage = 1;
        this.item.locations = [];
        this.updateItem(this.item);
      },

      searchItemLocations() {
        if (this.loadingLocations) {
          return;
        }

        this.loadingLocations = true;
        let conditions = [
          {
            logicalOperator: 'OR',
            conditions: [
              {
                joinType: 'LEFT',
                field: 'item.id',
                value: this.item.id
              },
              {
                joinType: this.positiveLocation ? 'INNER' : 'LEFT',
                field: 'balances.itemLot.item.id',
                value: this.item.id
              }
            ]
          }
        ];

        if (this.locationsSearchText && this.locationsSearchText.length) {
          conditions.push({
            field: 'name',
            conditionalOperator: 'LIKE_START',
            value: this.locationsSearchText
          });
        }
        shared.setLocalStorageString('items/show/Locations/locationsSearchText', this.locationsSearchText);


        if (this.locationsSelectedWarehouse && this.locationsSelectedWarehouse.id) {
          conditions.push({
            field: 'stockLocale.id',
            value: this.locationsSelectedWarehouse.id
          });
        }

        shared.setLocalStorageObj('items/show/Locations/locationsSelectedWarehouse', this.locationsSelectedWarehouse);


        if (this.locationsSelectedLot && this.locationsSelectedLot.id) {
          conditions.push({
            field: 'balances.itemLot.id',
            value: this.locationsSelectedLot.id
          });
        }

        shared.setLocalStorageObj('items/show/Locations/locationsSelectedLot', this.locationsSelectedLot);


        if (this.positiveLocation) {
          conditions.push({
            field: 'balances.entries',
            conditionalOperator: 'GREATER_THAN',
            expressionValue: 'balances.exits'
          });
        }

        shared.setLocalStorageString('items/show/Locations/positiveLocation', this.positiveLocation);

        httpClient
        .post(`${process.env.VUE_APP_API_URL}locations/select-and-where/with-quantity/sliced?page=${this.locationsCurrentPage - 1}&size=${this.locationsPerPage}`, {
          select: ['id', 'name', 'quantityMax', 'stockLocale.name', 'address', 'barcode'],
          where: {
            conditions: conditions,
            groupBy: ['id']
          }
        })
        .then(({ data }) => {
          this.loadingLocations = false;
          this.hasNextRow = !data.data.last;

          if (!this.item.locations) {
            this.item.locations = [];
          }

          this.item.locations.push(...data.data.content);
          this.currentPage = data.data.number + 1;
          this.locationsSearchedCallback(data.data.content);
          this.updateItem(this.item);
        })
        .catch((error) => {
          this.loadingLocations = false;
          if (error.message) {
            this.$notify.error(error)
          }

          this.item.locations = []
        });
      },

      locationsPageChanged(page) {
        this.locationsCurrentPage = page;
        this.searchItemLocations();
      },

      onScrollBottom() {
        if (!this.loadingLocations && this.hasNextRow) {
          this.locationsPageChanged(this.locationsCurrentPage+1);
        }
      }
    }
  }
</script>

<style scoped>
</style>
